/* istanbul ignore file */
import { parsers } from '@codegrade/utils';
/**
 * The result state of a job.
 */
export const TaskResultState = /* #__PURE__ */ parsers.exactly('not_started', 'started', 'finished', 'failed', 'crashed', 'skipped', 'revoked');
